{
  "details": "รายละเอียด",
  "image": "รูปภาพกิจกรรม",
  "startDate": "วันที่เริ่ม: {{date}}",
  "endDate": "วันที่สิ้นสุด: {{date}}",
  "rewardTarget": "ผู้มีสิทธิ์รับรางวัล: ระดับ VIP {{levels}}",
  "status": {
    "ongoing": "กำลังดำเนินการ",
    "ended": "สิ้นสุดแล้ว",
    "has-not-started": "ยังไม่เริ่ม"
  }
}
